<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25.503"
    height="24.893"
    viewBox="0 0 25.503 24.893"
  >
    <g transform="translate(3.141 0)">
      <path
        class="svg-primary"
        d="M11.808,1.936,10.279.166A.478.478,0,1,0,9.556.79l.411.475A9.334,9.334,0,0,0,0,9.679a.478.478,0,0,0,.43.521H.478a.478.478,0,0,0,.475-.432,8.376,8.376,0,0,1,9.056-7.545l-.6.515a.478.478,0,1,0,.624.723Z"
        transform="matrix(0.966, 0.259, -0.259, 0.966, 2.64, 0)"
      />
    </g>
    <path
      class="svg-primary"
      d="M21,268.2a3.006,3.006,0,1,0-2.683,0,5.184,5.184,0,0,0-3.834,5v.493h10.35v-.493A5.184,5.184,0,0,0,21,268.2Z"
      transform="translate(-14.488 -248.794)"
    />
    <path
      class="svg-primary"
      d="M24.68,271.409a4.7,4.7,0,1,0-4.2,0,8.108,8.108,0,0,0-6,7.818V280H30.677v-.771A8.108,8.108,0,0,0,24.68,271.409Z"
      transform="translate(-5.174 -255.105)"
    />
  </svg>
</template>

<script>
export default {};
</script>
